"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  DARK: 'dark',
  WHITE: 'white'
};
exports.default = _default;